<template>
    <page-wrapper>
        <q-breadcrumbs class="q-mt-none">
            <q-breadcrumbs-el icon="mib-server-settings-1" :label="$t('common.maintenance.system-temporarily-unavailable')" />
            <q-breadcrumbs-el v-if="isMaintenance" :label="$tc('common.maintenance.maintenance-mode', 1)" />
        </q-breadcrumbs>

        <div class="row q-col-gutter-md q-pa-lg justify-center">
            <div class="q-pt-xl col-xs-12 col-sm-8 col-md-6 col-lg-6 col-xl-4 self-center">
                <service-unavailable-content
                    :is-maintenance="isMaintenance"
                    @available="onAvailable"
                />
            </div>
        </div>
    </page-wrapper>
</template>

<script>
import ServiceUnavailableContent from '@/components/ServiceUnavailableContent.vue'
import { useRouter } from '@/composables/router'
import { Cookies } from 'quasar'

export default {
    name: 'Service Unavailable',
    components: {
        ServiceUnavailableContent,
    },
    props: {
        isMaintenance: {
            type: Boolean,
            default: false,
        },
    },
    meta () {
        return {
            title: this.$t('common.maintenance.maintenance-mode'),
        }
    },
    setup () {
        const router = useRouter()

        function onAvailable () {
            const isLoggedIn = Cookies.has('jwt_header_payload')
            const route = isLoggedIn ? { name: 'dashboard' } : { name: 'auth-login' }
            window.location.assign(router.resolve(route).href)
        }

        return {
            onAvailable,
        }
    },
}
</script>
